import { SessionMixin, cdnService, isMobileQuery } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { BREAKPOINT_DEVICE_UPDATED } from '@gig/magic-messages';
import '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import { LandingPageMixin } from '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let LandingComponent = class extends Mixins(LandingPageMixin, SessionMixin) {
  constructor() {
    super(...arguments);
    this.isMobile = false;
    this.hideSignUp = false;
    this.breakpointSubscription = null;
  }
  created() {
    this.breakpointSubscription = window.eventBus.subscribe(BREAKPOINT_DEVICE_UPDATED, (event) => __async(this, null, function* () {
      if (!event.payload) {
        return null;
      }
      this.isMobile = yield isMobileQuery();
    }), { replay: true });
  }
  destroyed() {
    var _a;
    (_a = this.breakpointSubscription) == null ? void 0 : _a.unsubscribe();
  }
  get landingPage() {
    var _a;
    const pageSlug = (_a = this.landingPages) == null ? void 0 : _a.find(({ slug }) => slug === this.slug);
    return pageSlug || null;
  }
  checkForPromoType() {
    const page = this.landingPage;
    if (page) {
      this.hideSignUp = page.types.some((type) => type.match("landing no signup"));
      this.hideSignUpForm();
    }
  }
  get background() {
    if (!this.landingPage || !this.landingPage.background) {
      return null;
    }
    const imageParams = {
      width: 1,
      height: 1
    };
    if (this.isMobile && this.landingPage.mobileBackground) {
      return cdnService.getLandingMobileBackgroundUrl(this.landingPage.mobileBackground, imageParams);
    }
    return cdnService.getLandingBackgroundUrl(this.landingPage.background, imageParams);
  }
  onLandingsLoad() {
    if (!this.isLoading && this.landingPages.length > 0 && !this.landingPage) {
      this.handleNotFound();
      return;
    }
    this.checkForPromoType();
  }
  handleNotFound() {
    return;
  }
  hideSignUpForm() {
    return this.hideSignUp;
  }
};
__decorateClass([
  Prop(String)
], LandingComponent.prototype, "slug", 2);
__decorateClass([
  Watch("isLoading", { immediate: true }),
  Watch("landingPages")
], LandingComponent.prototype, "onLandingsLoad", 1);
__decorateClass([
  Emit("notFound")
], LandingComponent.prototype, "handleNotFound", 1);
__decorateClass([
  Emit("hideLandingSignUp")
], LandingComponent.prototype, "hideSignUpForm", 1);
LandingComponent = __decorateClass([
  Component({
    name: "landing-page"
  })
], LandingComponent);

export default LandingComponent;
